import {
    container,
    backgroundContainer,
    main,
    progress,
    description,
    title,
    defaultFont,
    dangerColor,
    cardTitle
} from "@app/assets/jss/material-kit-pro-react.jsx";

const signInPageStyle = theme => ({
    progress : {
        ...progress,
        marginLeft: "-15px",
        marginRight: "-15px"
    },
    description,
    backgroundContainer,
    main: {
        ...main,        
        marginTop: "0px",
        paddingTop: "59px",
        "&:before": {
            background: "rgba(0, 0, 0, 0.5)",
            position: "absolute",
            width: "100%",
            height: "100%",
            minHeight: "100vh",
            display: "block",
            left: "0",
            top: "0",
            content: "''" 
        }
    },
    cardSignIn: {
        marginTop: "45px",
        marginBottom: "0px"
    },
    cardHeaderSignIn: {
        width: "auto",
        textAlign: "center",
        marginLeft: "20px",
        marginRight: "20px",
        padding: "20px 0",
        marginBottom: "15px"
    },
    cardBodySignIn: {
        padding: "0px 30px 0px 30px"
    },
    cardFooterSignIn: {
        paddingLeft: "20px",
        paddingRight: "20px",
        display: "flex",
        justifyContent: "center"
    },
    cardTitle: {
        ...cardTitle,
        color: "#FFFFFF !important",
        marginBottom: "10px !important"
    },
    container: {
        ...container,
        zIndex: "4",
        position: "relative",
        [theme.breakpoints.down("sm")]: {
            paddingBottom: "100px"
        }
    },
    form: {
        margin: "0"
    },
    inputIconsColor: {
        color: "#495057"
    },
    textCenter: {
        textAlign: "center"
    },
    iconButtons: {
        marginRight: "3px !important",
        marginLeft: "3px !important"
    },
    footer: {
        position: "absolute",
        width: "100%",
        background: "transparent",
        bottom: "0",
        color: "#fff",
        zIndex: "2"
    },
    title: {
        ...title,
        marginTop: "0px",
        marginBottom: "0px",
        textAlign: "center"
    },
    description: {
        color: "#999"
    },
    helperTextError: {
        ...defaultFont,
        color: dangerColor + " !important",
        fontSize: "12px",
        fontWeight: "400",
        lineHeight: "1.42857",
        top: "10px",
        marginTop: "10px"
    },
    textAlignCenter: {
        textAlign: "center"
    }
});

export default signInPageStyle;
